<template>
    <div v-if="page.total > 10" class="table-limit-select-wrap">
        <vue-select
            class="db-field-control f-b-custom-select table-limit-select"
            v-model="search.per_page"
            :options="limitOptions"
            label-by="name"
            value-by="id"
            :searchable="false"
            :closeOnSelect="true"
            @update:modelValue="limitChange"
        />
    </div>
</template>

<script>
export default {
    name: "TableLimitComponent",
    props: {
        page: { type: Object },
        search: { type: Object },
        method: { type: Function }
    },
    computed: {
        limitOptions() {
            return [
                { id: 10, name: "10" },
                { id: 25, name: "25" },
                { id: 50, name: "50" },
                { id: 100, name: "100" },
                { id: 250, name: "250" }
            ];
        }
    },
    methods: {
        limitChange: function () {
            this.method();
        }
    }
}
</script>

<style scoped>
.table-limit-select-wrap {
    width: 68px;
    min-width: 68px;
}
.table-limit-select {
    height: 2.25rem !important;
    min-height: 2.25rem !important;
    width: 100% !important;
    padding-left: 0.5rem !important;
    padding-right: 0.25rem !important;
    background-color: #fff !important;
    border-color: #d9dbe9 !important;
    border-radius: 0.375rem !important;
    font-size: 0.875rem !important;
    display: flex !important;
    align-items: center !important;
}
</style>

